import * as React from "react";
import { connect } from "react-redux";
import { navigate } from "~/router";
import { Overlay, SideModal, SideModalContent } from "~/common/layout/Modals";
import Head from "~/common/layout/Head";
import ProductSegmentForm from "../../components/products/ProductSegmentForm";
import { useCreateProductCategory } from "~/apps/pos/apis/productCategories";
import { ProductSegmentReq } from "~/apps/pos/models";

const ProductCategoryCreatePopup = () => {
  const { mutate: onCreate, error, isLoading } = useCreateProductCategory();

  const handleClose = () => {
    navigate("pos.admin.products.categories");
  };

  const handleSubmit = (data: ProductSegmentReq) => {
    onCreate(data, {
      onSuccess: () => {
        handleClose();
      },
    });
  };

  const initialValues = {
    name: "",
  };

  return (
    <Overlay onClick={handleClose} isLoading={isLoading}>
      <SideModal>
        <Head headTitle={"New category"} />
        <SideModalContent>
          <ProductSegmentForm
            initialValues={initialValues}
            error={error?.message || error?.errorMessage || ""}
            onSubmit={handleSubmit}
            onClose={handleClose}
          />
        </SideModalContent>
      </SideModal>
    </Overlay>
  );
};

export default ProductCategoryCreatePopup;
